import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { Colors } from '@/common/colors/colors';
import LinkedProducts from './components/linkedProducts/LinkedProducts';
import { SUPER_PRODUCT_MESSAGES } from '../../constants/superProduct';
import { FormBody, SaveRow, Title } from './SuperProductForm.styled';
import useSuperProductForm from './hooks/useSuperProductForm';

const SuperProductForm = ({ superProduct, products, onClose, onSaved }) => {
	const { name, setName, isEdit, linkedProducts, handleSubmit } =
		useSuperProductForm({
			superProduct,
			products,
			onSaved,
		});

	const formTitle = isEdit
		? SUPER_PRODUCT_MESSAGES.EDIT_SUPER_PRODUCT
		: SUPER_PRODUCT_MESSAGES.CREATE_SUPER_PRODUCT;

	return (
		<PopUp setShow={onClose}>
			<FormBody>
				<Title>{formTitle}</Title>
				<Input
					name={SUPER_PRODUCT_MESSAGES.NAME}
					controlled
					value={name}
					onChange={(event) => setName(event.target.value)}
					width={60}
					inputWidth={220}
					color={Colors.darkBlue}
				/>
				{isEdit && <LinkedProducts products={linkedProducts} />}
				<SaveRow>
					<ActionButton
						defaultText={
							isEdit
								? SUPER_PRODUCT_MESSAGES.SAVE
								: SUPER_PRODUCT_MESSAGES.CREATE
						}
						onClick={handleSubmit}
					/>
				</SaveRow>
			</FormBody>
		</PopUp>
	);
};

export default SuperProductForm;
